import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import { Box, Paper, Popper, Typography } from '@mui/material';
import React, { Component, createRef } from 'react';

interface Props {
    title: string;
    titleVariant: 'body2' | 'h6';
    videoUrl?: string;
}

interface State {
    isOpen: boolean;
}

class ExerciseHoverVideoTitle extends Component<Props, State> {
    private anchorRef = createRef<HTMLDivElement>();
    private closeTimeout?: ReturnType<typeof setTimeout>;

    state: State = {
        isOpen: false,
    };

    componentWillUnmount() {
        this.clearCloseTimeout();
    }

    onMouseEnter = () => {
        this.clearCloseTimeout();

        if (!this.props.videoUrl) {
            return;
        }

        this.setState({ isOpen: true });
    };

    onMouseLeave = () => {
        this.clearCloseTimeout();
        this.closeTimeout = setTimeout(() => {
            this.setState({ isOpen: false });
        }, 120);
    };

    clearCloseTimeout = () => {
        if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
            this.closeTimeout = undefined;
        }
    };

    render() {
        const { title, titleVariant, videoUrl } = this.props;
        const { isOpen } = this.state;
        const isHoverable = Boolean(videoUrl);

        return (
            <>
                <Box
                    onMouseEnter={this.onMouseEnter}
                    onMouseLeave={this.onMouseLeave}
                    ref={this.anchorRef}
                    sx={{
                        alignItems: 'center',
                        cursor: isHoverable ? 'pointer' : 'default',
                        display: 'inline-flex',
                        gap: 0.75,
                        maxWidth: '100%',
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 700,
                            textDecoration: isHoverable ? 'underline dotted' : 'none',
                            textDecorationColor: isHoverable ? 'primary.main' : 'transparent',
                            textUnderlineOffset: '0.18em',
                        }}
                        variant={titleVariant}
                    >
                        {title}
                    </Typography>
                    {isHoverable && <PlayCircleOutlineRoundedIcon color="primary" sx={{ fontSize: titleVariant === 'h6' ? 20 : 16 }} />}
                </Box>
                <Popper anchorEl={this.anchorRef.current} open={isOpen} placement="bottom-start" sx={{ zIndex: 1600 }}>
                    <Paper
                        elevation={8}
                        onMouseEnter={this.onMouseEnter}
                        onMouseLeave={this.onMouseLeave}
                        sx={{
                            borderRadius: 2,
                            mt: 1,
                            overflow: 'hidden',
                            width: 240,
                        }}
                    >
                        {videoUrl && (
                            <Box
                                component="video"
                                autoPlay
                                loop
                                muted
                                playsInline
                                preload="metadata"
                                src={videoUrl}
                                sx={{
                                    backgroundColor: 'common.black',
                                    display: 'block',
                                    height: 135,
                                    objectFit: 'cover',
                                    width: '100%',
                                }}
                            />
                        )}
                    </Paper>
                </Popper>
            </>
        );
    }
}

export default ExerciseHoverVideoTitle;